import { useAppSelector } from "@/store";
import { selectIsAuthenticated } from "@/store/auth";
import type { PropsWithChildren } from "react";
import { memo } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = memo(({ children }: PropsWithChildren) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return isAuthenticated ? children : <Navigate to="/login" />;
});

export default ProtectedRoute;
